import firebase from "firebase/app";
import 'firebase/auth'
import 'firebase/database'
import 'firebase/firestore'
import "firebase/storage";

const firebaseConfig = {
    apiKey: "AIzaSyBG5Mhh5o8YhR5DrrOR4kKnK6wYi7IVl7c",
    authDomain: "mail-hopper.firebaseapp.com",
    databaseURL: "https://mail-hopper.firebaseio.com",
    projectId: "mail-hopper",
    storageBucket: "mail-hopper.appspot.com",
    messagingSenderId: "624213091241",
    appId: "1:624213091241:web:8a447f5128773317"
  };

firebase.initializeApp(firebaseConfig);
firebase.firestore()
firebase.storage();

export default firebase;